module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface.htm"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/part_i_introduction.htm"
    }
  }, [_c('i', [_vm._v("Part I  Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_one_the_eve_of_battle.htm"
    }
  }, [_c('i', [_vm._v("Chapter One")]), _vm._v("  The Eve of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_two_battles_and_battlefields.htm"
    }
  }, [_c('i', [_vm._v("Chapter Two")]), _vm._v("  Battles and Battlefields")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/part_ii_the_elements_of_combat.htm"
    }
  }, [_c('i', [_vm._v("Part II  The Elements of Combat")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_three_artillery.htm"
    }
  }, [_c('i', [_vm._v("Chapter Three")]), _vm._v("  Artillery")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_four_light_infantry.htm"
    }
  }, [_c('i', [_vm._v("Chapter Four")]), _vm._v("  Light Infantry")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_five_infantry_combat.htm"
    }
  }, [_c('i', [_vm._v("Chapter Five")]), _vm._v("  Infantry Combat")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ORGANIZATION, FORMATIONS, DRILL AND TRAINING • MUSKETRY • BAYONETS AND HAND-TO-HAND FIGHTING • INFANTRY IN ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_six_cavalry_combat.htm"
    }
  }, [_c('i', [_vm._v("Chapter Six")]), _vm._v("  Cavalry Combat")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ORGANIZATION, EQUIPMENT AND TRAINING • CAVALRY IN ACTION • CAVALRY VS CAVALRY • CAVALRY VS ARTILLERY AND INFANTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/part_iii_command_and_control.htm"
    }
  }, [_c('i', [_vm._v("Part III  Command and Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_seven_the_role_of_the_general.htm"
    }
  }, [_c('i', [_vm._v("Chapter Seven")]), _vm._v("  The Role of the General")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_eight_subordinate_commanders_staff_officers_and_adcs.htm"
    }
  }, [_c('i', [_vm._v("Chapter Eight")]), _vm._v("  Subordinate Commanders, Staff Officers and ADCs")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_nine_regimental_officers.htm"
    }
  }, [_c('i', [_vm._v("Chapter Nine")]), _vm._v("  Regimental Officers")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_ten_morale_and_cohesion.htm"
    }
  }, [_c('i', [_vm._v("Chapter Ten")]), _vm._v("  Morale and Cohesion")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_eleven_attitudes_and_feelings.htm"
    }
  }, [_c('i', [_vm._v("Chapter Eleven")]), _vm._v("  Attitudes and Feelings")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "href": "#/part_iv_the_end_of_the_day.htm"
    }
  }, [_c('i', [_vm._v("Part IV  The End of the Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_twelve_victory_or_defeat.htm"
    }
  }, [_c('i', [_vm._v("Chapter Twelve")]), _vm._v("  Victory or Defeat?")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_thirteen_after_the_fighting.htm"
    }
  }, [_c('i', [_vm._v("Chapter Thirteen")]), _vm._v("  After the Fighting")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/epilogue.htm"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliographical_essay.htm"
    }
  }, [_vm._v("Bibliographical Essay")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0